<template>
  <article class="group__level-wrapper">
    <Level
      v-for="level in preparedLevels"
      :key="`level-${level.uuid}`"
      :level="level"
      :progress="progress"
    />
  </article>
</template>

<script>
import { mapState } from 'vuex'
import { cloneDeep } from 'lodash'
import uuid from 'uuid/v4'
import CONSTANTS from '@/constants'
import Level from '@/components/course/content/Level.vue'

export default {
  name: 'Levels',
  components: {
    Level,
  },
  props: {
    leaves: {
      type: Array,
      required: true,
    },
    progress: {
      type: [Object, String],
      required: false,
    },
  },
  data: () => {
    return {
      preparedLevels: [],
    }
  },
  computed: {
    ...mapState({
      currentLevels: state => state.courses.currentLevels,
    }),
  },
  methods: {
    prepareLevels() {
      const levels = []
      let exercisesGrouped = []
      let lastActivityReference = null

      for (let index = 0; index < this.leaves.length; index++) {
        const leaf = cloneDeep(this.leaves[index])
        const { content_type: type } = leaf
        const auxExercise = {}

        if (type === CONSTANTS.CONTENT_TYPES.EXERCISE) {
          exercisesGrouped.push(leaf)
        }

        if (
          exercisesGrouped.length &&
          (type !== CONSTANTS.CONTENT_TYPES.EXERCISE ||
            index === this.leaves.length - 1)
        ) {
          auxExercise.uuid = `u${uuid()}`
          auxExercise.content_type = CONSTANTS.CONTENT_TYPES.EXERCISE_GROUP
          auxExercise.last_activity = lastActivityReference
          auxExercise.exercises = exercisesGrouped
          if (!this.currentLevels.includes(auxExercise)) {
            this.$store.dispatch('courses/updateCurrentLevels', auxExercise)
          }
          levels.push(auxExercise)
          exercisesGrouped = []
        }
        if (
          !this.currentLevels.includes(leaf) &&
          type !== CONSTANTS.CONTENT_TYPES.EXERCISE
        ) {
          if (type === CONSTANTS.CONTENT_TYPES.QUIZ) {
            leaf.last_activity = lastActivityReference
          }
          if (type === CONSTANTS.CONTENT_TYPES.VIDEO) {
            // if next is quiz add to leaf for button into video feature
            if (
              index < this.leaves.length - 1 &&
              this.leaves[index + 1].content_type ===
                CONSTANTS.CONTENT_TYPES.QUIZ
            ) {
              leaf.quiz = this.leaves[index + 1]
            }
          }
          this.$store.dispatch('courses/updateCurrentLevels', leaf)
          levels.push(leaf)
        }
        if (
          [
            CONSTANTS.CONTENT_TYPES.VIDEO,
            CONSTANTS.CONTENT_TYPES.IFRAME,
            CONSTANTS.CONTENT_TYPES.SLIDES,
          ].includes(type)
        ) {
          lastActivityReference = leaf
        }
      }
      this.preparedLevels = levels
    },
  },
  mounted() {
    this.prepareLevels()
  },
}
</script>
